import { Cart } from "../cart/cart";

const cart = new Cart();

$(document).on("click", ".js-click", function (event) {
  event.preventDefault();

  const $this = $(this);
  const $element = $($this.attr("href"));

  if (!$element.length) {
    return;
  }

  $this.add($element).toggleClass("is-active");

  if ($this.hasClass("js-trigger-no-scroll")) {
    if ($("body").hasClass("no-scroll")) {
      $("body").removeClass("no-scroll");
    } else {
      $("body").addClass("no-scroll");
    }
  }
});

$(document).on("click", "[js-quick-add]", function (e) {
  e.preventDefault();
  const items = [];
  const variantId = $(this).data("id");
  const item = {
    id: variantId,
    quantity: 1,
  };

  $(this).text("Adding...");

  items.push(item);

  // reload page after ajax if on cart page
  if ($(".template-cart").length > 0) {
    $.ajax({
      url: "/cart/add.js",
      context: this,
      type: "POST",
      dataType: "json",
      data: { items },
      success(res) {
        window.location.reload();
      },
      error(err) {
        alert(err.responseJSON.description);
        $(this).text("Add to bag");
      },
    });
  } else {
    cart.add(items);

    setTimeout(() => {
      $(this).text("Add to bag");
    }, 1000);
  }
});
